import sectionsByIdFunc from 'utils/forms/sectionsByID'

export default (conversationItem, getState) => {
  // console.log('conversationItem', conversationItem)
  const typesObj = {
    sms: () => conversationItem?.sms?.body,
    formsub: () => {
      console.log('hits formsub()')

      if (conversationItem.formsub?.submittal_uri) {
        const form =
          getState().data?.customform?.[
            conversationItem?.formsub?.custom_form_uri?.slice?.(12)
          ]

        const sectionsByID = sectionsByIdFunc(form)

        const response =
          getState().data?.['customform/entry']?.[
            conversationItem?.formsub?.submittal_uri?.slice?.(18)
          ]
        const contact_fields = response?.contact_fields || {}
        const custom_fields = response?.custom_fields || {}

        const answers = {
          ...contact_fields,
          ...custom_fields,
        }

        const keys = Object.keys(answers)

        const keyValueString = keys.reduce((acc, key) => {
          // this needs to change to be the label:
          acc += `${sectionsByID?.[key]?.label || key}: ${answers[key]}, `
          return acc
        }, '')

        return `Here is a form response from the contact: \`\`\`${keyValueString}\`\`\``
      }

      return 'The contact filled out a form but there seems to be a problem retrieving it.'
    },
  }

  if (typesObj?.[conversationItem?.type]) {
    return typesObj[conversationItem?.type]()
  }

  return 'Unknown message'
}
